import type { Key } from "../game/round";
import "./Keypad.css";

const KEYS: Key[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "⌫", "0", "Go"];

interface Props {
  onPress: (key: Key) => void;
  disabled?: boolean;
}

export function Keypad({ onPress, disabled = false }: Props) {
  return (
    <div className="pad" role="group" aria-label="Number keypad">
      {KEYS.map((k) => (
        <button
          key={k}
          type="button"
          className={"key display" + (k === "Go" ? " go" : "")}
          aria-label={k === "⌫" ? "Delete" : k}
          aria-disabled={disabled || undefined}
          onPointerDown={(e) => {
            // Fire on pointer down so answers feel instant on touch; prevent the
            // focus/scroll side effects a tap would otherwise cause.
            e.preventDefault();
            if (!disabled) onPress(k);
          }}
          onKeyDown={(e) => {
            if ((e.key === "Enter" || e.key === " ") && !disabled) {
              e.preventDefault();
              onPress(k);
            }
          }}
        >
          {k}
        </button>
      ))}
    </div>
  );
}
